import { Component, Input, Output, EventEmitter, HostBinding} from '@angular/core';


@Component({
    selector: 'br-slider',
    templateUrl: './br-slider.component.html'
})
export class BrSliderComponent {

    private _tickInterval = 1;

    // --- OPTIONS --- 
    @Input() autoTicks:boolean  = true;
    @Input() disabled:boolean   = false;
    @Input() invert:boolean     = false;
    @Input() max:number         = 100;
    @Input() min:number         = 0;
    @Input() showTicks:boolean  = true;
    @Input() step:number        = 1;
    @Input() thumbLabel:boolean = true;
    @Input() value:number       = 0;
    @Input() vertical:boolean   = false;    
    @Input() thumbLabelPosition:string = 'bottom';
    @Input() width:string = '100%';
    // --- end: OPTIONS ---
    
    @Output() onSliderChange: EventEmitter<any> = new EventEmitter<any>();
    @HostBinding('class.thumb-label-bottom') thumbPosition: boolean = (this.thumbLabelPosition === 'bottom')? true : false;
    

    get tickInterval(): number | 'auto' {
        return this.showTicks ? (this.autoTicks ? 'auto' : this._tickInterval) : 0;
    }

    set tickInterval(v) {
        this._tickInterval = Number(v);
    }

    emit(e) {
        this.onSliderChange.emit(e.value);
    }
}




// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/br-slider/br-slider.component.ts